import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import ManageMitigationTaskModal from "./ManageMitigationTaskModal.vue";

export default {
    name: "MitigationTasksModal",
    components: { customModal, ManageMitigationTaskModal },
    props: {
        data: Object,
    },
    emits: ["closeModal"],

    data() {
        return {
            taskList: [],
            showAddTaskModal: false,
            selectedTask: null,
        };
    },

    mounted() {
        console.log("data..", this.data)
        if (this.data && this.data.id) {
            this.getMitigationTasks();
        } else {
            this.buildTaskList();
        }
    },

    watch: {
        data: {
            deep: true,
            handler() {
                if (this.data && this.data.id) {
                    this.getMitigationTasks();
                } else {
                    this.buildTaskList();
                }
            },
        },
    },

    methods: {
        buildTaskList() {
            if (!this.data || !Array.isArray(this.data.mitigationActions)) {
                this.taskList = [];
                return;
            }
            this.taskList = this.data.mitigationActions.map(t => ({ ...t, expanded: false }));
        },
        async getMitigationTasks() {
            const token = store.getters.getIdToken;
            const baseurl = process.env.VUE_APP_Service_URL;
            try {
                const response = await axios.get(
                    `${baseurl}/forms/ctq/getmitigationtasks/${this.data.id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const result = response.data || [];
                this.taskList = result.map(t => ({ ...t, expanded: false }));
            } catch (error) {
                console.error("Error fetching mitigation tasks:", error);
                this.taskList = [];
            }
        },
        toggleExpand(task) {
            task.expanded = !task.expanded;
        },

        truncate(text) {
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        closeModal() {
            this.$emit("closeModal");
        },

        getCadenceBadgeClass(cadence) {
            if (!cadence) return "secondary";
            const lower = cadence.toLowerCase();
            if (lower === "monthly") return "primary";
            if (lower === "per visit") return "info";
            if (lower === "per ecg event") return "warning";
            return "secondary";
        },
        onTaskSaved() {
            this.showAddTaskModal = false;
            if (this.data && this.data.id) {
                this.getMitigationTasks();
            } else {
                this.buildTaskList();
            }
        },
        openEditTask(task) {
            this.selectedTask = task;
            this.showAddTaskModal = true;
        },
    },
};